/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SmsCp {
  Magfa = 1,
  Asanak = 2,
  Armaghan = 3,
  RahyabRG = 4,
  RahyabPG = 5,
  SLS = 6,
  PishgamRayan = 8,
  SocialNetworks = 9,
  Avanak = 10,
  Idehgate = 12,
  PishgamRayan2 = 13,
  Irancell = 14,
  MCI = 15,
  Kando = 16,
  Rightel = 17,
  Mxb = 18,
  PishgamRayan3 = 19,
  Twilio = 20
}
